import { Component, OnInit } from '@angular/core';

import { AdminService } from '../../services/admin.service';
import { Global } from '../../../app.global';
import { GlobalObservables } from '../../../app.global.observer';
import { QuestionService } from '../../../shared/common/services/question.service';
import { SettingsService } from '../../../authentication/services/settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'policies-list',
  templateUrl: './policies-list.component.html',
  styleUrls: ['./policies-list.component.scss'],
})
export class PoliciesListComponent implements OnInit {
  selectedPolicies = [];
  policyCategories = [];
  visiblePolicies = [];
  selectedPolicyCat = '';
  permitTemplateItems = [
    'payDisplay',
    'business',
    'contract',
    'doctors',
    'marketTraders',
    'seasonTicket',
  ];
  savePolicyStatus = '';
  showDynamicPolicies = false;

  constructor(
    private adminService: AdminService,
    public global: Global,
    private globalObs: GlobalObservables,
    private questionServ: QuestionService,
    private settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    this.setSelectedPoliciesAnswers();

    this.settingsService.getApplicationSetting('Policies.Dynamic.Enabled').subscribe((value) => {
      this.showDynamicPolicies = value === true || value === 'true' || value === '1';
      this.setPolicies();
    });
  }

  setPolicies() {
    this.adminService.getPoliciesRoot().subscribe((result) => {
      if (!result) {
        return;
      }

      const policiesList: any[] = [];

      result.forEach((category) => {
        if (category.childItems === null) {
          policiesList.push(category);
        } else {
          category.childItems.forEach((subCategory) => {
            if (subCategory.id === 'concessionsOther') {
              subCategory.description = 'other concessions';
            } else if (subCategory.id === 'concessionsPayment') {
              subCategory.description = 'payment evidence';
            }

            if (subCategory.childItems === null) {
              policiesList.push(subCategory);
            } else {
              subCategory.childItems.forEach((child) => {
                child.description = `${child.description} permit`;
                policiesList.push(child);
              });
            }
          });
        }
      });

      if (this.showDynamicPolicies) {
        policiesList.push({
          id: 'dynamicPolicies',
          description: 'additional policies',
        });
      }

      this.policyCategories = policiesList;

      if (this.policyCategories.length > 0) {
        this.selectedPolicyCat = this.selectedPolicyCat || this.policyCategories[0].id;
      }
    });
  }

  setSelectedPoliciesAnswers() {
    this.adminService.getAllPolicies().subscribe((result) => {
      if (result) {
        this.global.policiesAnswers = result;
        this.globalObs.onPoliciesAnswersSetted.next(true);
        this.questionServ.setLocalPoliciesAnswers(result);
      }
    });
  }

  savePolicies(policyList) {
    this.savePolicyStatus = '';
    this.adminService.savePolicies(policyList).subscribe(
      (res) => {
        if (res) {
          this.setSelectedPoliciesAnswers();
          this.savePolicyStatus = 'success';
        } else {
          this.savePolicyStatus = 'error';
        }
      },
      () => {
        this.savePolicyStatus = 'error';
      }
    );
  }

  selectPolicyCategory(section) {
    this.selectedPolicyCat = section.id;
    this.savePolicyStatus = '';
  }
}
